import React, { FC, useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { useSelector, useDispatch, useI18n, useButton } from '~Hooks';
import LoginModal from '../LoginModal';
import * as actions from '~actions';
import { BlackButton } from '~Styles';

const Wrapper = styled.div`
  margin-right: auto;
`;

const Button = styled(BlackButton)`
  height: 56px;
  width: 152px;
  padding: 4px;
  position: relative;
  display: flex;
  flex-direction: column;
`;

const StaffName = styled.span`
  max-width: 90%;
  text-transform: capitalize;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 600;
  font-size: 14px;
  margin-top: 1px;
  width: auto;
  letter-spacing: 0.2px;
  color: var(--colorBlueGray200);
  line-height: 1.2;
`;

const StaffSignIn: FC = () => {
  const dispatch = useDispatch();
  const [showLogin, setShowLogin] = useState(false);
  const staff = useSelector((state) => (state.companyStaff?.staffs.length ? state.staff : false));
  const companyStaff = useSelector((state) => state.companyStaff);
  const { i18n } = useI18n();

  const staffs = companyStaff?.staffs ?? [];
  const staffId = staff ? staff.id : null;
  const staffName = staff ? staff.name : null;

  useEffect(() => {
    if (staffId && showLogin) {
      setShowLogin(false);
    }
  }, [staffId]);

  const logOutButton = useButton({
    onClick: () => dispatch(actions.staffLogout()),
  });

  const logInButton = useButton({
    onClick: () => setShowLogin(true),
  });

  if (!staffs.length) {
    return null;
  }

  return (
    <Wrapper>
      {staffId ? (
        <Button {...logOutButton}>
          {i18n('General.Logout')}
          <StaffName>{staffName}</StaffName>
        </Button>
      ) : (
        <Button {...logInButton}>{i18n('General.Login')}</Button>
      )}
      {showLogin && <LoginModal onClose={() => setShowLogin(false)} />}
    </Wrapper>
  );
};

export default React.memo(StaffSignIn);
